import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'hospitality-bot-create-with-view',
  templateUrl: './create-with-view.component.html',
  styleUrls: ['./create-with-view.component.scss'],
})
export class CreateWithViewComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @Input() isLoaded: boolean;
  @Input() onboardingUrl: string;
  @Input() allowedIframeOrigin?: string;
  @Input() allowedIframeOrigins?: string[] = [
    'https://accounts.zoho.in',
    'https://dev.createwith.botshot.ai',
    'https://stg.createwith.botshot.ai',
    'https://createwith.botshot.ai',
    'http://localhost:3000',
  ];
  @ViewChild('onboardingFrame') iframeRef: any;

  isIframeLoaded = false;
  iframeSrc: string;

  sendMessageToIframe(message: any) {
    const iframe = this.iframeRef?.nativeElement;
    if (!iframe) return;

    const targetOrigin =
      this.allowedIframeOrigin ||
      (this.allowedIframeOrigins?.length ? this.allowedIframeOrigins[0] : '*');

    iframe.contentWindow?.postMessage(message, targetOrigin);
  }

  private handleMessage = (event: MessageEvent) => {
    const target = event?.data?.navigate;
    if (!target) return;

    const origin = event.origin;

    if (this.allowedIframeOrigins?.length) {
      if (!this.allowedIframeOrigins.includes(origin)) return;
    } else if (this.allowedIframeOrigin) {
      if (origin !== this.allowedIframeOrigin) return;
    }

    window.location.href = target;
  };

  ngOnInit(): void {
    window.addEventListener('message', this.handleMessage);
    this.iframeSrc = this.onboardingUrl;
  }
  onIframeLoad() {
    this.isIframeLoaded = true;

    const pendingCode = sessionStorage.getItem('oauthCodeFromNavigate');
    if (pendingCode) {
      this.sendMessageToIframe({ oauthCode: pendingCode });
      sessionStorage.removeItem('oauthCodeFromNavigate');
    }
  }

  ngAfterViewInit(): void {
    try {
      const urlCode = new URLSearchParams(window.location.search).get('code');

      if (urlCode) {
        try {
          sessionStorage.setItem('oauthCodeFromNavigate', urlCode);
        } catch {}

        try {
          let newIframeUrl: URL;
          try {
            newIframeUrl = new URL(this.onboardingUrl);
          } catch {
            newIframeUrl = new URL(this.onboardingUrl, window.location.origin);
          }
          newIframeUrl.searchParams.set('code', urlCode);
          newIframeUrl.searchParams.set('tab', 'invoice');
          this.iframeSrc = newIframeUrl.toString();
        } catch {}

        try {
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('code');
          history.replaceState(null, '', cleanUrl.toString());
        } catch {}

        return;
      }
    } catch {}
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.handleMessage);
  }
}
